module.exports = __webpack_public_path__ + "static/media/icon-event__los-grandes-imperios-europeos-hover.d4b03980.svg";